import {
  QueryCondition,
  QueryOperation,
  SearchQuery,
} from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import _ from "lodash";
import { hasValue } from "../utils/string";
import { InputObject } from "../controls/default";
import { CompanyVessel } from "../repository/data.default";
import { nameOf } from "../utils/typescript";

export interface VesselsViewForm {
  readonly name?: string;
  readonly code?: string;
  readonly type?: InputObject;
}

export const vesselsViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: nameOf<CompanyVessel>("name"),
    width: 192,
    sort: true,
        fixed: 'left'
  },
  {
    title: "Code",
    key: nameOf<CompanyVessel>("code"),
    width: 192,
    sort: true,
  },
  {
    title: "Type",
    key: nameOf<CompanyVessel>("typeName"),
    width: 192,
    sort: true,
  },
];

export function mapVesselsViewQuery(values: VesselsViewForm): SearchQuery {
  const conditions: QueryCondition[] = Object.entries(values)
        .filter(([key, value]) =>
      hasValue(value),
    )
    .map(([key, value]) => {
      switch (key) {
        case nameOf<VesselsViewForm>("name"):
          return {
            field: nameOf<CompanyVessel>("name"),
            values: [value],
            operation: QueryOperation.StartsWith,
          };
        case nameOf<VesselsViewForm>("code"):
          return {
            field: nameOf<CompanyVessel>("code"),
            values: [value],
            operation: QueryOperation.StartsWith,
          };
        case nameOf<VesselsViewForm>("type"):
          return {
            field: nameOf<CompanyVessel>("typeUid"),
            values: [(value as InputObject).value],
            operation: QueryOperation.Equal,
          };
      }
    })
    .filter((f) => !!f) as QueryCondition[];

  return {
    conditions,
  };
}
